import React from 'react';
import PropTypes from 'prop-types';
import './HighlightLabel.scss';

export const HighlightLabel = (props) => {
  const { children, extendClass = '' } = props;

  return (
    <span
      className={`highlight-label ${extendClass}`}
      data-testid="highlight-label"
    >
      {children}
    </span>
  );
};

HighlightLabel.propTypes = {
  children: PropTypes.string.isRequired,
  extendClass: PropTypes.string,
};
